import { color } from "@smoothincorg/smooth-ui"
import Link from "next/link"
import React from "react"
import { formatDate } from "src/components/List/List"
import { Proposal } from "src/hooks/useProposalSWR"
import { useSmoothApi } from "src/hooks/useSmoothApi"
import { CamelCase, camelCase } from "src/lib/aikagi"
import { SMOOTH_SMOOTHER_API_URL } from "src/lib/constants"
import { V1_OPE_URL } from "src/lib/constants/value"
import useSWR from "swr"
// import { useEditingId } from "../../hooks/useEditingId"
import { ModalEditableForm } from "../ModalEditableForm/ModalEditableForm"
import * as styles from "./SearchHouses.css"
import { sortById } from "../User/User"
import { BorderedButtonAnchor } from "src/components/Button/BorderedButton"

type SnakeSearchHouse = {
  id: number
  proposal_id: number
  rent_lower: number
  rent_upper: number
  rent_include: string[]
  moving_target_on: string
  tab: null
  prefecture: string
  breadth_lower: number
  breadth_upper: number
  build_const: string[]
  build_type: string[]
  building_age: string
  madori: string[]
  ambiguous: string
  route_line: string[]
  walk: string
  stations: string[]
  target_cities: string[]
  target_pref: string | null
  requirement: string
  special: string[]
  house_urls: string[]
  enabled: boolean
  created_at: string
  updated_at: string
  moving_purpose: string[]
}

type SearchHouse = CamelCase<SnakeSearchHouse>

export const useProposalsSearchHousesSWR = (proposalId: number) => {
  const { getWithToken } = useSmoothApi()

  return useSWR(`${SMOOTH_SMOOTHER_API_URL}/proposals/${proposalId}/search_houses`, async (url) => {
    const response = await getWithToken(url)
    return response.data["data"].map((d: Proposal) => camelCase(d)) as SearchHouse[]
  })
}

export const SearchHouses: React.FC<{
  limit?: number
  proposalId: number
}> = ({ proposalId, limit = 100000 }) => {
  const resourceName = `Proposal.${proposalId}.searchHouses`

  const { data } = useProposalsSearchHousesSWR(proposalId)

  const showPageAttributes: (keyof SearchHouse)[] = [
    "rentUpper",
    "rentLower",
    "targetCities",
    "stations",
    "routeLine",
  ]

  return (
    <div className={styles.root}>
      <h2 className={styles.title}>
        お部屋探しの希望条件（{data?.length || 0}）
        <BorderedButtonAnchor
          href={`${V1_OPE_URL}/admin/search_houses/new?proposal_id=${proposalId}`}
          target="_blank"
          style={{
            marginLeft: "1rem",
            background: "#ffffff",
            display: "inline-block",
            fontWeight: "normal",
          }}
        >
          新規作成
        </BorderedButtonAnchor>
      </h2>
      <section>
        {sortById(data ?? [])
          ?.filter((_, index) => index < limit)
          ?.map((searchHouse, index, array) => {
            const previousSearchHouse = array[index + 1]

            return (
              <div key={searchHouse.id} className={styles.movingApplication}>
                <ModalEditableForm
                  resourceName={resourceName}
                  resource={searchHouse}
                  opeHref={V1_OPE_URL + "/admin/search_houses/" + searchHouse.id}
                  temporary_EDIT_IN_SMOOTHER_OPE_URL={
                    V1_OPE_URL + "/admin/search_houses/" + searchHouse.id
                  }
                  items={[
                    ...showPageAttributes.map((attr) => {
                      const isChangedFromPrevious =
                        previousSearchHouse &&
                        JSON.stringify(previousSearchHouse[attr]) !==
                          JSON.stringify(searchHouse[attr])

                      return [
                        attr,
                        <div key={attr}>
                          <>
                            {searchHouse[attr] instanceof Array
                              ? (searchHouse[attr] as string[])
                                  .filter((s: string, i) => i < 20)
                                  .join(", ")
                              : searchHouse[attr]}
                            {isChangedFromPrevious && (
                              <span
                                key={attr}
                                style={{
                                  marginLeft: "1rem",
                                  color: color.red,
                                  fontSize: "1.2rem",
                                }}
                              >
                                {searchHouse[attr] instanceof Array
                                  ? `変更あり`
                                  : `変更前:${previousSearchHouse[attr]}`}
                              </span>
                            )}
                          </>
                        </div>,
                      ] as [string, JSX.Element]
                    }),
                    ["createdAt", formatDate(searchHouse.createdAt)],
                    ["updatedAt", formatDate(searchHouse.updatedAt)],
                  ]}
                  onSubmit={(e) => console.log(e)}
                />
              </div>
            )
          })}

        {data?.length > limit && (
          <Link
            href={`/admin/proposals/${proposalId}/search-houses`}
            style={{
              color: color.main,
              textDecoration: "underline",
              fontSize: "1.4rem",
            }}
          >
            一覧を見る
          </Link>
        )}
      </section>
    </div>
  )
}
